// C1 «لما بضيف قسم جديدة محتاجها تفتح في صفحة جديدة مستقلة بعيده عن الصفحة
// الاساسية ولما احفظ البيانات تفتح الصفحة اللي فيها كل الاقسام».
//
// The add/edit form used to be a second panel permanently stapled under the
// list on the same screen: it was always visible even when nobody was adding
// anything, "edit" silently re-pointed it from under the user, and after saving
// you were left looking at a form instead of the list you just changed.
// department-form.vue is now its own route for both add and edit (mirroring the
// admin portal's formPages()), and these are its pure, testable parts.

/** A blank form. `isActive` defaults true — a new department is live. */
function blankDepartment() {
  return { nameAr: '', managerName: '', isActive: true };
}

/** API row → form shape. Nulls become '' so the inputs stay controlled. */
function departmentToForm(row) {
  var r = row || {};
  return {
    nameAr: r.nameAr == null ? '' : String(r.nameAr),
    managerName: r.managerName == null ? '' : String(r.managerName),
    isActive: r.isActive === undefined ? true : !!r.isActive,
  };
}

/**
 * Validate. Returns {field: errorKey}; empty object = valid.
 * `nameAr` min length is 2 to match CreateDepartmentDto — validating only
 * "non-empty" here let a 1-character name reach the API and come back a 400
 * the form could not explain.
 */
function validateDepartment(form) {
  var f = form || {};
  var errors = {};
  var name = String(f.nameAr == null ? '' : f.nameAr).trim();
  if (!name) errors.nameAr = 'nameRequired';
  else if (name.length < 2) errors.nameAr = 'nameTooShort';
  else if (name.length > 120) errors.nameAr = 'nameTooLong';

  var manager = String(f.managerName == null ? '' : f.managerName).trim();
  if (manager.length > 120) errors.managerName = 'managerTooLong';
  return errors;
}

/**
 * Form → request body. An empty manager is sent as `null`, not omitted and not
 * '': on a PATCH, omitting a key means "leave it alone", so a user clearing the
 * manager field could never actually clear it.
 */
function buildDepartmentPayload(form) {
  var f = form || {};
  var manager = String(f.managerName == null ? '' : f.managerName).trim();
  return {
    nameAr: String(f.nameAr == null ? '' : f.nameAr).trim(),
    managerName: manager === '' ? null : manager,
    isActive: !!f.isActive,
  };
}

var SAVE_API_ERRORS = {
  COMPANY_CONTEXT_MISSING: 'forbidden',
  DEPARTMENT_NOT_FOUND: 'notFound',
};

/** Server error → i18n key, so the form never shows a raw backend string. */
function saveErrorKey(err) {
  var e = err || {};
  var res = e.response;
  if (!res) return 'network';
  var code = res.data && res.data.code;
  if (code && SAVE_API_ERRORS[code]) return SAVE_API_ERRORS[code];
  if (res.status === 403) return 'forbidden';
  if (res.status === 404) return 'notFound';
  if (res.status === 400 || res.status === 422) return 'validation';
  return 'generic';
}

module.exports = {
  blankDepartment: blankDepartment,
  departmentToForm: departmentToForm,
  validateDepartment: validateDepartment,
  buildDepartmentPayload: buildDepartmentPayload,
  SAVE_API_ERRORS: SAVE_API_ERRORS,
  saveErrorKey: saveErrorKey,
};
